module.exports = __webpack_public_path__ + "static/media/power-button-on.276fabf2.png";